import { type JSX } from 'react'
import { FormattedMessage } from 'react-intl'

import { erxBonusLandingPageTextBreak } from '../../../../components/ErxBonusLandingPageTranslationValues'

type ErxBonusLandingPageFaqDataItem = {
  details: JSX.Element
  key: string
  summary: JSX.Element
}

export const ErxBonusLandingPageFaqData: ErxBonusLandingPageFaqDataItem[] = [
  {
    details: (
      <FormattedMessage
        id="deErx.oldBonus.ErxBonusFaqSection.faq.HowIsBonusCalculated.details"
        values={{ break: erxBonusLandingPageTextBreak }}
      />
    ),
    key: '0-faq',
    summary: (
      <FormattedMessage
        id="deErx.oldBonus.ErxBonusFaqSection.faq.HowIsBonusCalculated.summary"
        values={{ break: erxBonusLandingPageTextBreak }}
      />
    ),
  },
  {
    details: (
      <FormattedMessage
        id="deErx.oldBonus.ErxBonusFaqSection.faq.WhereToFindBonus.details"
        values={{ break: erxBonusLandingPageTextBreak }}
      />
    ),
    key: '1-faq',
    summary: (
      <FormattedMessage id="deErx.oldBonus.ErxBonusFaqSection.faq.WhereToFindBonus.summary" />
    ),
  },
  {
    details: (
      <FormattedMessage
        id="deErx.oldBonus.ErxBonusFaqSection.faq.PrivateRxBonusNotCharged.details"
        values={{ break: erxBonusLandingPageTextBreak }}
      />
    ),
    key: '2-faq',
    summary: (
      <FormattedMessage id="deErx.oldBonus.ErxBonusFaqSection.faq.PrivateRxBonusNotCharged.summary" />
    ),
  },
  {
    details: (
      <FormattedMessage
        id="deErx.oldBonus.ErxBonusFaqSection.faq.BonusInCash.details"
        values={{ break: erxBonusLandingPageTextBreak }}
      />
    ),
    key: '3-faq',
    summary: (
      <FormattedMessage id="deErx.oldBonus.ErxBonusFaqSection.faq.BonusInCash.summary" />
    ),
  },
  {
    details: (
      <FormattedMessage
        id="deErx.oldBonus.ErxBonusFaqSection.faq.DoesBonusExpire.details"
        values={{ break: erxBonusLandingPageTextBreak }}
      />
    ),
    key: '4-faq',
    summary: (
      <FormattedMessage id="deErx.oldBonus.ErxBonusFaqSection.faq.DoesBonusExpire.summary" />
    ),
  },
  {
    details: (
      <FormattedMessage
        id="deErx.oldBonus.ErxBonusFaqSection.faq.OrderOtherProductsInRedemption.details"
        values={{ break: erxBonusLandingPageTextBreak }}
      />
    ),
    key: '5-faq',
    summary: (
      <FormattedMessage id="deErx.oldBonus.ErxBonusFaqSection.faq.OrderOtherProductsInRedemption.summary" />
    ),
  },
]
